import { makeStyles } from '@mui/styles';
import { Grid, IconMenuButton, Typography } from 'apollo-react';
import { EllipsisVertical } from 'apollo-react-icons';
import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';

import { downloadLogFile } from './actions/import.actions';
import ItemsTable from '../components/EditorDashboard/ItemsTable';
import { useTranslation } from '../custom-hooks/useTranslation';

const useStyles = makeStyles({
  main: {
    padding: 20,
    backgroundColor: '#fff',
  },
  title: {
    fontSize: '24px',
    fontWeight: 600,
    fontStretch: 'normal',
    fontStyle: 'normal',
    lineHeight: 1,
    letterSpacing: 'normal',
    color: '#000',
    marginLeft: 17,
    padding: '24px 20px 18px 5px',
  },
});

const savedSearchName = 'Application Migration Import History';

const AppMigrationHistory = () => {
  const classes = useStyles();
  const translateString = useTranslation();
  const dispatch = useDispatch();

  useEffect(() => {
    document.title = translateString('Application Migration History');
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleFileDownload = ({ importKey, fileName }) => {
    dispatch(downloadLogFile({ importKey, fileName }));
  };

  const getMenuItems = ({ row }) => [
    {
      text: `${translateString('Download')} ${row.AMP_ZIP_FILE_NAME}`,
      onClick: () => handleFileDownload({ importKey: row.AMP_ID, fileName: row.AMP_ZIP_FILE_NAME }),
      hidden: !row.AMP_ZIP_FILE_NAME,
    },
    {
      text: translateString('Download Log'),
      onClick: () => handleFileDownload({ importKey: row.AMP_ID, fileName: row.AMP_LOG_FILE_NAME }),
      hidden: !row.AMP_LOG_FILE_NAME,
    },
    {
      text: translateString('Download Form Log'),
      onClick: () =>
        handleFileDownload({ importKey: row.AMP_ID, fileName: row.AMP_FORMS_LOG_FILE_NAME }),
      hidden: !row.AMP_FORMS_LOG_FILE_NAME,
    },
    {
      text: translateString('Download Workflow Log'),
      onClick: () =>
        handleFileDownload({ importKey: row.AMP_ID, fileName: row.AMP_WF_LOG_FILE_NAME }),
      hidden: !row.AMP_WF_LOG_FILE_NAME,
    },
  ];

  const extraColumns = [
    {
      index: 6,
      header: '',
      accessor: '',
      fixedWidth: true,
      customCell: ({ row }) => {
        const menuItems = getMenuItems({ row });

        return (
          <IconMenuButton id="actions" menuItems={menuItems.filter((action) => !action.hidden)}>
            <EllipsisVertical />
          </IconMenuButton>
        );
      },
    },
  ];

  return (
    <Grid container>
      <Grid item xs={12}>
        <Typography className={classes.title}>
          {translateString('Application Migration History')}
        </Typography>
      </Grid>
      <Grid item xs={12}>
        <div className={classes.main}>
          <ItemsTable
            entityName="V_AMP_APP_MIGRATION_PCKGS"
            initialSearchName={savedSearchName}
            itemTitle={translateString(savedSearchName)}
            extraColumns={extraColumns}
          />
        </div>
      </Grid>
    </Grid>
  );
};
export default AppMigrationHistory;
